import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { pushObjArray } from 'src/app/services/convert.service';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-add-answer-exercise-book-club',
  templateUrl: './add-answer-exercise-book-club.component.html',
  styleUrls: ['./add-answer-exercise-book-club.component.scss']
})
export class AddAnswerExerciseBookClubComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  answer: AbstractControl;
  isCorrect: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new option';

  constructor(
    public dialogRef: MatDialogRef<AddAnswerExerciseBookClubComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: BookstoreStore,
    private ds: DataService,
  ) { }

  ngOnInit() {
    const { ANSWER } = this.data;
    this.form = this.fb.group({
      answer: [ANSWER ? ANSWER.name : null, Validators.compose([Validators.required])],
      isCorrect: [ANSWER ? ANSWER.isCorrect : false],
    })
    if (ANSWER) {
      this.TITLE = "Edit option";
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.error = null;
    if (this.form.valid) {
      const { answer, isCorrect } = f;
      const { ANSWER } = this.data;
      const answers =this.store.options
      const row = {
        key: ANSWER ? ANSWER.key : this.ds.createId(),
        name: `${answer}`,
        isCorrect: isCorrect || false,
      };
      const options = pushObjArray(answers, row)
      this.store.options = options;
      this.form.reset();
      this.inputEl.nativeElement.focus();
      if(!isNew){
        this.dialogRef.close('yes')
      }
      if (ANSWER) {
        this.dialogRef.close('yes')
      }
    }
  }
}